const isArray = Array.isArray;
let idCount = 0;

function uniqueId(prefix) {
  return `${(prefix == null ? '' : prefix) + (++idCount)}`;
}

export function notify(handler, args) {
  handler && handler(...(isArray(args) ? args : [args]));
}

export function instanceId(component, suffix = '') {
  component.__id || (component.__id = uniqueId('rw_'));
  return (component.props.id || component.__id) + suffix;
}

export function isFirstFocusedRender(component) {
  // eslint-disable-next-line no-return-assign
  return component._firstFocus || (component.state.focused && (component._firstFocus = true));
}
